<template>
  <div>
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="80px"
          inline
          @submit.native.prevent
          size="small"
        >
          <el-form-item label="申请单号">
            <el-input
              v-model="filter.order_number"
              autocomplete="off"
              placeholder="搜索单号"
              @keyup.enter.native="
                filter.page = 1
                getData()
              "
            ></el-input>
          </el-form-item>
          <el-form-item label="申请基地" v-if="!condition.personal">
            <BaseSelect
              v-model="filter.base_id"
              :clearable="true"
              :filterBlank="true"
            ></BaseSelect>
          </el-form-item>
          <el-form-item label="审批基地" v-if="!condition.approving">
            <BaseSelect
              v-model="filter.approve_base_id"
              :clearable="true"
              :filterBlank="true"
            ></BaseSelect>
          </el-form-item>
          <el-form-item label="申请状态" v-if="!condition.approving">
            <ItemStatusSelect
              v-model="filter.status"
              model="apply"
              :clearable="true"
            ></ItemStatusSelect>
          </el-form-item>
          <el-form-item label="申请日期">
            <el-date-picker
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="margin-left: 80px">
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData()
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="
          model = {}
          dialogVisible = true
        "
        v-if="canAdd"
        >物资申请</el-button
      >
      <el-table :data="list" size="small" class="mt-10">
        <el-table-column prop="order_number" label="单号 / 审批基地">
          <template slot-scope="scope">
            {{ scope.row.order_number }}
            <br />
            {{ scope.row.approve_base.name }}
          </template>
        </el-table-column>
        <el-table-column prop="base.name" label="申请信息" min-width="100">
          <template slot-scope="scope">
            <div>申请人：{{ scope.row.user.name }}</div>
            <div>
              申请基地/钻井：{{
                scope.row.well.well_number || scope.row.base.name
              }}
            </div>
            <div v-if="scope.row.status > 1">
              申请时间：{{
                $time(scope.row.created_at).format('YYYY-MM-DD HH:mm')
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="申请明细" min-width="150">
          <template slot-scope="scope">
            <div v-for="item in scope.row.items" :key="item.id">
              <el-tag size="mini"
                >{{ item.product_template.name || item.item_template.name
                }}{{ item.model_number ? `（${item.model_number}）` : ''
                }}<i class="ml-10">x {{ item.quantity }}</i></el-tag
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="申请备注"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <ItemStatus :status="scope.row.status" model="apply"></ItemStatus>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <template
              v-if="
                (scope.row.status == 1 || scope.row.status == 4) &&
                scope.row.user_id == $store.state.userInfo.id
              "
            >
              <el-popconfirm
                title="确认删除该申请吗？"
                @confirm="hanldeDelte(scope.row, scope.$index)"
              >
                <el-button
                  slot="reference"
                  v-permission="Auth.applyNew"
                  type="text"
                  size="small"
                  class="text-danger"
                  >删除</el-button
                >
              </el-popconfirm>
              <el-button
                type="text"
                size="small"
                class="ml-5"
                @click="handleEdit(scope.$index, scope.row)"
                v-permission="Auth.applyNew"
                >编辑</el-button
              >
              <el-popconfirm
                title="确认提交审批吗？"
                @confirm="handleApplyStart(scope.row, scope.$index)"
              >
                <el-button
                  class="ml-5"
                  slot="reference"
                  v-permission="Auth.applyNew"
                  type="text"
                  size="small"
                  >提交审批</el-button
                >
              </el-popconfirm>
            </template>
            <el-button
              type="text"
              size="small"
              class="ml-5"
              @click="$router.push(`${$route.path}/${scope.row.id}`)"
              >详情</el-button
            >
            <!-- <el-button
              v-if="scope.row.status == 2 && hasAuth('applyApprove')"
              type="text"
              size="small"
              class="ml-5"
              @click="handleApprove(scope.row, scope.$index)"
              >审批</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>

      <Former
        :model="model"
        :show.sync="dialogVisible"
        @created="createdCallback"
        @updated="updatedCallback"
      ></Former>

      <ApproveFormer
        :model="model"
        :show.sync="approveDialogVisible"
        @updated="updatedCallback"
      ></ApproveFormer>
    </div>
  </div>
</template>

<script>
import { applyList, applyDelete, applyStart } from '@/service/getData'
import Former from './former'
import BaseSelect from '@/components/select/base_select.vue'
import ApproveFormer from './approve_former.vue'

export default {
  props: {
    condition: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Former,
    ApproveFormer,
    BaseSelect,
  },
  watch: {
    'filter.page': function () {
      this.getData()
    },
  },
  computed: {
    canAdd() {
      return this.condition.personal && this.hasAuth('applyNew')
    },
  },
  data() {
    return {
      model: {},
      filter: {
        page: 1,
        size: 10,
        status: '',
        base_id: '',
        approve_base_id: '',
        date: '',
        order_number: '',
      },
      total: 0,
      editIndex: 0,
      list: [],
      dialogVisible: false,
      approveDialogVisible: false,
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = this.filterDecode(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.status = ''
        this.filter.base_id = ''
        this.filter.approve_base_id = ''
        this.filter.date = ''
        this.filter.order_number = ''
      }

      this.$router.replace({
        query: this.filterEncode(this.filter),
      })

      let params = Object.assign({}, this.filter, this.condition)
      params.page -= 1
      if (params.date && params.date.length == 2) {
        params.start_date = params.date[0]
        params.end_date = params.date[1]
      }

      let res = await applyList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.count
      }
    },
    createdCallback(data) {
      this.list.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.list, this.editIndex, data)
    },
    handleEdit(index, item) {
      this.model = this.clone(item)
      this.editIndex = index
      this.dialogVisible = true
    },

    async handleApplyStart(item, index) {
      let res = await applyStart(item.id)
      if (res.code == 0) {
        this.$set(this.list, index, res.data)
      }
    },

    handleApprove(item, index) {
      this.model = {
        items: item.items,
        id: item.id,
        pass: '',
        remark: '',
      }
      this.editIndex = index
      this.approveDialogVisible = true
    },

    async hanldeDelte(item, index) {
      let res = await applyDelete(item.id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
  },
}
</script>